/**
 * A few bespoke glyphs to replace the default Lucide icons that appear
 * dozens of times across the site (the single most recognisable
 * "built from a component library" tell). Thinner stroke than Lucide's
 * default 2px, matching the hairline weight used everywhere else
 * (dividers, section-tag rules, borders).
 */
export function Arrow({ className = "h-4 w-4" }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <path
        d="M3.5 12h16.25M12.75 5 20 12l-7.25 7"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
